// @flow
import { Schema } from "../../../components/form";

const formSchema = new Schema({
  password: {
    type: "string",
    required: true
  },
  passwordConfirmation: {
    type: "string",
    required: true,
    validator: (value, allValues) => {
      if (value !== allValues.password) {
        return "A senha e sua confirmação devem ser iguais";
      }
    }
  }
});

export default formSchema;
